import BaseModel from '../core/BaseModel'
import ShowroomModel from '@/models/ShowroomModel'

export default class RentalOrderModel extends BaseModel {

    constructor() {
        super({

                name: "rental_order_sell",
                tableName: 'rental_order_sell',
                label: "Purchase Request",
                // display_key: 'fullname' 
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                avatar: {
                    name: "avatar",
                    label: "Image",
                    custom: 'image',
                    type: "Computed",
                    computed: (data, index) => {
                        data.avatar = index + 1;
                    },
                    width: 3,
                    class : 'left'
                },
                rental_order_id: {
                    name: 'rental_order_id',
                    type: "Uuid",
                    label: 'Order ID',
                    filter: {type: 'input', match: 'contains'},
                    class : 'left'
                },
                
                sell_plate_number: {
                    name: 'sell_plate_number',
                    type: "String",
                    label: 'Plate Number',
                    filter: {type: 'input', match: 'contains'},
                    class : 'left'
                },
                user : {
                    name: 'user',
                    type: "computed",
                    label: 'User',
                    computed: (data) => {
                        data.user ='' ;
                    },
                    filter: {type: 'input', match: 'contains'},
                    class : 'left',
                    width : 15,
                },
                fullname: {
                    name: 'fullname',
                    type: "String",
                    label: 'Contact Name',
                    filter: {type: 'input', match: 'contains'}, 
                    width : 15,
                    class : 'left'
                }, 

               
                price: {
                    name: 'price',
                    type: "Numeric",
                    label: 'Price',
                    width : 8,
                    class : 'left'
                },
                sell_showroom_id: {
                    name: 'sell_showroom_id',
                    type: "Computed",
                    label: 'Showroom',
                    models: new ShowroomModel(),
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    width : 8,
                    class : 'left',
                    computed: (data) => {
                        data.showroom_id = '';
                    },
                },
                
                sell_drop_off_date :{
                    name: 'sell_drop_off_date',
                    type: "String", 
                    label: 'Appointment',
                    filter: { type: 'DateRange', match: 'contains' },
                },


                booking_status : {
                    name: 'booking_status',
                    type: "select",
                    label: 'Status',
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    options: [
                        {value: 'REQUEST_SELL', label: 'Request'},
                        {value: 'REJECT_SELL', label: 'Reject'},
                        {value: 'COMPLETE_SELL', label: 'Complete'},
                        {value: 'CANCEL_SELL', label: 'Cancel'},
                        {value: 'APPROVE_SELL', label: 'Approve'},

                        
                    ],
                    computed: (data) => {
                        data.booking_status ='' ;
                    },
                    class : 'left'
                },
                source : {
                    name: 'source',
                    type: "computed",
                    label: 'Source',
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    options: [
                        {value: 'WEB', label: 'Website', style: 'color:  #000000;'},
                        {value: 'IOS', label: 'Ios',style: 'color:  #000000;'},
                        {value: 'ANDROID', label: 'Android',style: 'color:  #000000;'},
                    ],
                    computed: (data) => {
                        data.source ='' ;
                    },
                    class:"left",
                    width : 8,
                },
                updated_by: {
                    name: 'updated_by',
                    type: "Uuid",
                    label: 'Updated By',
                    width : 10,
                    class : 'left'
                },
                updated_at: {
                    name: 'updated_at',
                    type: "Timestamp",
                    label: 'Updated date',
                    default: 'now()',
                    class : 'left'
                },
                detail_get: {
                    refs:  ' rental_order {is_edit_admin id type_order code booking_status car_status ref_email uid source showroom_id note point_reward user {id fullname point_wallet } } showroom { id name address manager_uid } update_user {id fullname}',
                    display: false
                },
                detail_get1 : {
                    refs : 'sell_rego_validation odometer price fullname phone email price_sale reject_reason',
                    display: false
                }
            }
        );
    }
}
